// export const API_URL = window.location.protocol + "//" + window.location.host + "/api";
export const API_URL = 'https://pbot.admortgage.com/api'
export const LOGIN_URL = API_URL + "/auth/login/";
export const CHANGE_PASSWORD_URL = API_URL + "/auth/password/";
export const SETTINGS_URL = API_URL + "/settings/";
export const FORMS_URL = API_URL + "/forms/";
export const WIKI_URL = API_URL + "/wiki/";
export const MYSELF_URL = API_URL + "/myself";
